export const toInviteList = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    return value?.data ?? [];
};
const roleKey = (role) => (role ?? '').trim().toLowerCase();
export const activeInviteWave = (invites) => {
    const incomplete = invites
        .filter((invite) => invite.ec__status !== 'complete')
        .sort((left, right) => (left.ec__order ?? 0) - (right.ec__order ?? 0));
    if (!incomplete.length) {
        return [];
    }
    const minOrder = incomplete[0].ec__order ?? 0;
    return incomplete.filter((invite) => (invite.ec__order ?? 0) === minOrder);
};
export const isRoleInActiveWave = (role, invites) => {
    if (!role) {
        return false;
    }
    const key = roleKey(role);
    return activeInviteWave(invites).some((invite) => roleKey(invite.ec__signer_role) === key);
};
/**
 * A user holding several invites gets the earliest outstanding one, so an invite already in the
 * current wave is never hidden behind a later one.
 */
export const findOwnInvite = (invites, email) => {
    const key = email.trim().toLowerCase();
    if (!key) {
        return undefined;
    }
    const own = invites.filter((invite) => (invite.ec__email ?? '').trim().toLowerCase() === key);
    return activeInviteWave(own)[0] ?? own[0];
};
/**
 * Display-only: an outstanding invite outside the current wave locks the signing surface. It never
 * grants signing; the server's accepted-signer check stays authoritative.
 */
export const isInviteOutOfTurn = (invite, invites) => {
    if (!invite || invite.ec__status === 'complete') {
        return false;
    }
    const waveOrder = activeInviteWave(invites)[0]?.ec__order ?? 0;
    return (invite.ec__order ?? 0) !== waveOrder;
};
export const isDelayedSigningLocked = (doc) => {
    if (!doc || doc.ec__pts || doc.ec__document_template?.ec__pts_only) {
        return false;
    }
    if (doc.ec__document_template?.ec__delayed_signing !== true) {
        return false;
    }
    return doc.ec__can_sign_document !== true;
};
